import React from "react";

import styled from "styled-components";
import {subduedTextColour} from "../../../style/styleConsts";
import Metric, {MetricValue} from "./Metric";

export const CompanyRankText = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
`;

const Context = styled.div`
    color: ${subduedTextColour};
`;

function indicator(i) {
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}

function toOrdinal(rank) {
    return rank ? rank + indicator(rank) : '\u2014';
}

const CompanyRankMetric = ({companyRank, totalCompanyCount}) => (
    <Metric label={"Company Rank"}>
        <CompanyRankText>
            <MetricValue>{toOrdinal(companyRank)}&nbsp;</MetricValue>
            <Context>of {totalCompanyCount}</Context>
        </CompanyRankText>
    </Metric>
);

export default CompanyRankMetric;
